import type { ReactNode } from "react";

const NBFC_NAME: string = import.meta.env.VITE_COMPANY_NBFC || "";
const NBFC_URL = "https://fintechcloud.com/";

export const NbfcLink = ({ className = "" }: { className?: string }) => (
  <a
    href={NBFC_URL}
    target="_blank"
    rel="noopener noreferrer"
    className={`hover:underline ${className}`}
  >
    {NBFC_NAME}
  </a>
);

// Wraps every occurrence of the NBFC name inside plain text with a link to its website.
// eslint-disable-next-line react-refresh/only-export-components
export const linkifyNbfc = (text: ReactNode): ReactNode => {
  if (typeof text !== "string" || !NBFC_NAME || !text.includes(NBFC_NAME)) return text;
  return text.split(NBFC_NAME).flatMap((part, i) =>
    i === 0 ? [part] : [<NbfcLink key={i} />, part]
  );
};
